import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { withRouter } from 'react-router';
import { Form, Input, Row, Col, Button, Menu, Card } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';


class AddCarrier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyName: "",
            customerName: "",
            phoneNumber: "",
            email: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            loading: false,
            confirmDirty: false,
        }
    }

    hasErrors = fieldsError => Object.keys(fieldsError).some(field => fieldsError[field]);
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log("no errors");
                this.props.history.push('/app/carriers');
            }
        });
    }
    handleConfirmBlur = e => {
        const { value } = e.target;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };
    
    render() {
        const {
            getFieldDecorator
        } = this.props.form;

        // const props = {
        //     name: 'file',
        //     multiple: true,
        //     action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        //     onChange(info) {
        //         const { status } = info.file;
        //         if (status !== 'uploading') {
        //             console.log(info.file, info.fileList);
        //         }
        //         if (status === 'done') {
        //             message.success(`${info.file.name} file uploaded successfully.`);
        //         } else if (status === 'error') {
        //             message.error(`${info.file.name} file upload failed.`);
        //         }
        //     },
        // };
        return (
            <div style={{ position: 'absolute', top: '135px', width: '100%' }}>
                <Row style={{ margin: '20px' }}>

                    <Menu mode="horizontal" style={{ backgroundColor: 'rgb(14, 77, 144)' }} >
                        <Menu.Item key="1" ><Link to="/app/carriers"><h3 style={{ color: '#fff' }}><ArrowLeftOutlined style={{ fontSize: '1em' }} />Back</h3></Link></Menu.Item>
                        <Menu.Item key="3" style={{cursor: 'default'}}><h2 style={{ color: '#fff' }}>New Carrier</h2></Menu.Item>

                    </Menu>
                </Row>

                <Row >
                    <Col lg={5} md={5} sm={24} xs={24} offset={9}>
                        <div className="site-card-border-less-wrapper">
                            <Form onSubmit={this.handleSubmit}  >

                                <Card title="Carrier Details" style={{borderRadius: '10px'}}>


                                    <Row>
                                        <Col lg={24} md={24} sm={24} sx={24}>
                                            <Form.Item className="Formitem"
                                                label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Company</span>}>
                                                {getFieldDecorator('companyName', {
                                                    rules: [{ required: true, message: 'Please input Company Name!' }],
                                                })(<Input setFieldsValue={this.state.companyName} />)}
                                            </Form.Item>
                                        </Col>
                                        <Col lg={24} md={24} sm={24} sx={24}>
                                            <Form.Item className="Formitem"
                                                label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Customer Name</span>}>
                                                {getFieldDecorator('Customer Name', {
                                                    rules: [{ required: true, message: 'Please input Customer Name!' }],
                                                })(<Input setFieldsValue={this.state.customerName} />)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={24} md={24} sm={24} sx={24}>
                                            <Form.Item className="Formitem" label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Phone</span>}>
                                                {getFieldDecorator('phoneNumber', {
                                                    rules: [{ message: 'The input is not valid phone number!', },
                                                    { required: true, message: 'Please input your phone number!' }],
                                                })(<Input  setFieldsValue={this.state.phoneNumber} />)}
                                            </Form.Item>
                                        </Col>
                                        <Col lg={24} md={24} sm={24} sx={24}>
                                            <Form.Item className="Formitem" label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Email</span>}>
                                                {getFieldDecorator('email', {
                                                    rules: [{ type: 'email', message: 'The input is not valid E-mail!', },
                                                    { required: true, message: 'Please input your E-mail!', },],
                                                })(<Input setFieldsValue={this.state.email}/>)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={24} md={24} sm={24} sx={24}>
                                            <Form.Item className="Formitem"
                                                label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Address</span>}>
                                                {getFieldDecorator('address', {
                                                    rules: [{ required: true, message: 'Please input your Address!' }],
                                                })(<Input setFieldsValue={this.state.address}/>)}
                                            </Form.Item>
                                        </Col>
                                        <Col lg={24} md={24} sm={24} sx={24}>
                                            <Form.Item className="Formitem"
                                                label={<span style={{ color: '#7B8190', fontSize: '14px' }}>City</span>}>
                                                {getFieldDecorator('city', {
                                                    rules: [{ required: true, message: 'Please input your City!' }],
                                                })(<Input setFieldsValue={this.state.city}/>)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12} md={12} sm={24} sx={24}>
                                            <Form.Item className="Formitem"
                                                label={<span style={{ color: '#7B8190', fontSize: '14px' }}>State</span>} >
                                                {getFieldDecorator('state', {
                                                    rules: [{ required: true, message: 'Please input your State!' }],
                                                })(<Input setFieldsValue={this.state.state}/>)}
                                            </Form.Item>
                                        </Col>
                                        <Col lg={12} md={12} sm={24} sx={24}>
                                            <Form.Item className="Formitem"
                                                label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Zip</span>}>
                                                {getFieldDecorator('zip', {
                                                    rules: [{ required: true, message: 'Please input your Zip!' }],
                                                })(<Input setFieldsValue={this.state.zip}/>)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                                <Row>
                                    <Form.Item style={{ marginTop: '10px' }}>
                                        <Button type="primary" style={{ backgroundColor: '#25559517', color: '#255595', marginRight: '30px', padding: '0 20px 0 20px', border: 'none' }}>
                                            <Link to="/app/carriers">
                                                Cancel</Link>
                                        </Button>
                                        <Button type="primary" htmlType="submit" style={{ float: 'right', backgroundColor: '#255595', color: 'white', marginRight: '30px', padding: '0 20px 0 20px' }}   >
                                            Save        
                                        </Button>
                                    </Form.Item>
                                </Row>
                            </Form>

                        </div>
                    </Col>
                </Row>
            </div>
        )


    }


}
export default Form.create({ name: 'addcarrier' })(withRouter(AddCarrier));